import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HorusMessageGeneralComponent } from '../../shared/components/domain/horus-message-general/horus-message-general.component';

@Component({
  selector: 'app-not-selected-tenant',
  standalone: true,
  imports: [HorusMessageGeneralComponent],
  templateUrl: './not-selected-tenant.component.html',
  styleUrl: './not-selected-tenant.component.scss'
})
export class NotSelectedTenantComponent {
  private route = inject(ActivatedRoute);

  get message(): string {
    const url = this.route.snapshot.url;
    const segment = url.length > 0 ? url[0].path : '';
    
    const moduleMessages: Record<string, string> = {
      'orders': 'Pedidos',
      'messaging': 'Comunicaciones',
      'services': 'Servicios', 
      'invoices': 'Comprobantes',
      'stock-physical': 'Consulta de stock',
      'search-stores': 'Búsqueda de tiendas'
    };

    const moduleName = moduleMessages[segment] || 'Comunicaciones';
    return `Aquí aparecerá la data correspondiente a <${moduleName}> del cliente.`;
  }
}